// const userTextConfig = {

//   179750: {
//     check_in: "arrival_request",
//     check_out: "departure_request",
//     lowest_price_ever: "best_invitational_price_ever",
//     useHotelType: true,
//   },
// };

const commonConfig = {
  check_in: "arrival_request",
  check_out: "departure_request",
  lowest_price_ever: "best_invitational_price_ever",
  useHotelType: true,
  cancel_booking: "cancel_booking_request",
  existing_booking_cancel: "existing_booking_cancel_request",
};

const userTextConfig = {
  179750: commonConfig,
};

export const getTextKey = (userId, defaultKey) => {
  console.log("key", userId);
  return userTextConfig[userId]?.[defaultKey] || defaultKey;
};
export const shouldUseHotelType = (userId) => {
  return userTextConfig[userId]?.useHotelType || false;
};

export { userTextConfig };
